import {
  ApplicabilityItemEnum,
  CabinPreferenceEnum,
  MacroCategoryEnum,
  PriceBasisEnum,
  PriceTypeEnum,
} from '@msc-b2c/interfaces/enums';
import { ICabinPreferenceResponseCruises } from '../../../../../../interfaces/src/lib/interfaces/index';

// 1. Import this mock response where the getPriceLists is called with first arg -> BookingAPIEndpoints.CABINPREFERENCES
// 2. Comment out the getPriceLists execution and set the data state with the following response.
// 3. setloading to false

// example: at the CabinPreferenceCardsWrapper:
// setPreferenceCardsData(responseCabinPreferensesMock.cabinPreferences);
// setLoading(false);
export const responseCabinPreferensesMock: ICabinPreferenceResponseCruises = {
  cabinPreferences: [
    {
      cabinPreference: CabinPreferenceEnum.REAL,
      lowestPricedCategory: {
        cabinType: 'Interior',
        priceType: 'PROMOMKT',
        priceCode: 'DIC00969GB5014PR',
        priceDescription: 'Save and Sail Cruise Only',
        categoryCode: 'IR1',
        macroCategory: MacroCategoryEnum.INSIDE,
        allowedOccupancies: '2,3,4',
        passengerType: '',
        portChargesAmount: '0.00',
        totalAllInclusiveCabinPrice: {
          beforeDiscount: '2437.00',
          afterDiscount: '2437.00',
        },
        totalCabinPrice: {
          beforeDiscount: '2437.00',
          afterDiscount: '2437.00',
        },
        maximumOccupancy: {
          real: 4,
          guaranteed: 0,
        },
        pricesPerPassenger: [
          {
            passengerId: '-9999',
            allInclusive: {
              beforeDiscount: '1029.00',
              afterDiscount: '1029.00',
            },
            charges: [
              {
                chargeType: 'CAB',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '1029.00',
                  afterDiscount: '1029.00',
                },
                gross: {
                  beforeDiscount: '1029.00',
                  afterDiscount: '1029.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          {
            passengerId: '-9998',
            allInclusive: {
              beforeDiscount: '1029.00',
              afterDiscount: '1029.00',
            },
            charges: [
              {
                chargeType: 'CAB',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '1029.00',
                  afterDiscount: '1029.00',
                },
                gross: {
                  beforeDiscount: '1029.00',
                  afterDiscount: '1029.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          {
            passengerId: '-9997',
            allInclusive: {
              beforeDiscount: '379.00',
              afterDiscount: '379.00',
            },
            charges: [
              {
                chargeType: 'CHD',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '379.00',
                  afterDiscount: '379.00',
                },
                gross: {
                  beforeDiscount: '379.00',
                  afterDiscount: '379.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
        ],
        items: [
          {
            code: 'SPABAEXP',
            date: '2025-03-14',
            description: 'Balinese Massage 50 Minute',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '160.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 4,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573154754',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'SPA',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'DUOPR',
            date: '2025-03-14',
            description: 'Duo - Two Exclusive Dining Experiences',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '141.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 4,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573154776',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'FORFAI',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'SPASWEXP',
            date: '2025-03-14',
            description: 'Swedish Massage  - 50 min',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '154.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 4,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573154791',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'SPA',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'B2BK215',
            date: '2025-03-14',
            description: 'INTERNET BROWSE - 2 DEVICES',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '460.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 4,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573154805',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'COMM',
            typeCode: 'OBS',
            costCurrency: 'USD',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'BS2BK215',
            date: '2025-03-14',
            description: 'INTERNET BROWSE & STREAM - 2 DEVICES',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '580.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 4,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573154819',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'COMM',
            typeCode: 'OBS',
            costCurrency: 'USD',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'EXP2B',
            date: '2025-03-14',
            description: 'Fantastica Experience Benefits',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 31,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573155996',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'MISC',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'SCUI814',
            date: '2025-03-14',
            description: 'SERVICE CHARGE - GRATUITIES are included in the cruise fare',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 41,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156100',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'SERVICEC',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: '603',
            date: '2025-03-14',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 46,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156150',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            typeCode: 'MSC',
            parentPackageCode: '',
            serviceType: '',
            description: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
            costCurrency: '',
          },
        ],
      },
      allowedOccupancies: '',
      maximumOccupancy: {
        real: 0,
        guaranteed: 0,
      },
    },
  ],
};
